// extracted by mini-css-extract-plugin
module.exports = {"item":"_5D1RJxGG","icon":"_5D2wlRkz","name-container":"_5D2JPn6q","name-link":"_5D3P1fzO","name-link__label":"_5D2OLtym","description":"_5D3scY42","flags":"_5D1cshMN"};